module.exports = __webpack_public_path__ + "01ccd2b4425b3727f527c7e38f218373.MP3";